import { IndividualWalletBalanceRequest, IndividualWalletCloseRequest, Wallets } from "../../../models/FinancialData";
import { Result } from "../../../models/Result";
import { httpService } from "../../HttpService";

class UserWalletApiService {
    path: string = "IndividualWallet";

    /**
     * App-facing read: the customer must be Active. Use this wherever the wallet is about to be
     * acted on - picking a transfer target, for instance - because a deactivated, closed or
     * blocked customer must not be offered.
     */
    getWallets = async(userId: number): Promise<Result<Wallets[]>> => await httpService.get<Wallets[]>(`/${this.path}/${userId}/wallets`);

    /**
     * Back-office read: returns the customer's wallets whatever their status. Use this for viewing
     * a customer's record - a deactivated, closed or blocked customer still holds wallets, and
     * those are exactly the accounts compliance and support open to check a balance or a blocked
     * amount. Requires crm:wallets:view-any-status, which wallet users do not hold.
     */
    getBackOfficeWallets = async(userId: number): Promise<Result<Wallets[]>> => await httpService.get<Wallets[]>(`/${this.path}/back-office/${userId}/wallets`);

    getWalletBalance = async (request: IndividualWalletBalanceRequest): Promise<Result<Wallets>> => await httpService.post<Wallets>(`/${this.path}/wallet-balance`, request);
        
    closeWallet = async (request: IndividualWalletCloseRequest): Promise<Result<void>> => await httpService.post<void>(`/${this.path}/close-wallet`, request);
}

const userWalletApiService = new UserWalletApiService();

export {userWalletApiService};